import * as React from "react";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {createStyles, makeStyles, Theme} from "@material-ui/core";
import { Viewer } from "./js/main";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuItem: {
      fontSize: "0.875em",
    }
  }),
);

export const ContextMenu = (props) => {
  const classes = useStyles();
  const viewer = props.viewer as Viewer;
  const {state, setContextState, setViewerTooltipText} = props;

  const onClose = () => {
    setContextState({
      mouseX: null,
      mouseY: null,
      id: null,
      isPoint: null
    });
  };

  const onEnter = () => {
    setViewerTooltipText("");
  };

  const getMenuItems = () => {
    let numHighlighted = viewer.numHighlighted();
    let labelActive = viewer.checkIfActive();
    // No labelling
    if (numHighlighted === 0 || !labelActive) {
      return [
        {
          text: `${viewer.orbitState ? "Disable" : "Enable"} 3D Mode`,
          disabled: !(viewer.hasPoints && viewer.cameraSelected),
          callback: () => {
            viewer.controls.toggleCamera();
          }
        },
        {
          text: "Reset 3D Mode",
          disabled: !viewer.orbitState,
          callback: () => {
            viewer.controls.resetCamera();
          }
        }
      ];
    }
    // With Labelling
    else if (numHighlighted > 0) {
      return [
        {
          text: `Delete Selected Labels (${numHighlighted})`,
          disabled: (viewer.anyLabelSelected()),
          callback: () => {
            viewer.deleteHighlighted();
          }
        },
        {
          text: `Delete Selected Point`,
          disabled: (viewer.anyLabelSelected() || !state.isPoint),
          callback: () => {
            viewer.imageLabels.deletePoint(state.isPoint);
          }
        },
        {
          text: `Unselect All Labels`,
          disabled: viewer.anyLabelSelected(),
          callback: () => {
            viewer.unHighlightAll();
          }
        },
        {
          text: "Edit Label",
          disabled: (viewer.anyLabelSelected() || numHighlighted > 1),
          callback: () => {
            viewer.selectLabel(state.id);
          }
        }
      ];
    }

    return [];
  };

  const options = viewer ? getMenuItems() : [];
  const anchorPosition = state.mouseY !== null && state.mouseX !== null
    ? { top: state.mouseY, left: state.mouseX }
    : undefined;

  const open = state.mouseY !== null;

  return (
    <Menu
      keepMounted
      open={open}
      onClose={onClose}
      onEnter={onEnter}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
    >
      {options.map(option => {
        return (
          <MenuItem
            key={option.text}
            disabled={option.disabled}
            className={classes.menuItem}
            onClick={() => {
              onClose();
              option.callback();
            }}
          >
            {option.text}
          </MenuItem>
        );
      })}
    </Menu>
  );
};